/* Penseur Trading — landing page behavior.
 *
 * The page is fully static HTML; this file adds the three live touches the
 * old React build had. Without JS (or with prefers-reduced-motion) the page
 * still renders complete: all alert rows visible, form inert, no marquee.
 */

import { attachWaitlist } from './waitlist.ts';

/* ── invite forward ──────────────────────────────────────────────────────
 * The console SPA that redeems invites lives under /dashboard/. An invite link
 * that lands on the marketing root (/?invite=...) would otherwise render this
 * landing page and silently drop the code, so forward it to the SPA, preserving
 * the query string + hash. Runs first, before any animation work. */
{
  const search = window.location.search;
  if (new URLSearchParams(search).has('invite')) {
    window.location.replace('/dashboard/' + search + window.location.hash);
  }
}

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── motion gate ─────────────────────────────────────────────────────────
 * CSS animations (ticker marquee, LED pulse, fresh-dot pulse) key off
 * .pt-anim-on, which the static markup ships with. Swap it off for
 * reduced-motion users. */
const root = document.querySelector('.pt-root');
if (reduceMotion && root) {
  root.classList.replace('pt-anim-on', 'pt-anim-off');
}

/* ── live alert feed ─────────────────────────────────────────────────────
 * The markup ships all rows. With motion allowed, start at 4 and reveal one
 * row every 2.6s (newest gets the enter animation), wrapping back to 4 —
 * the same cadence the React version ran. */
const feed = document.querySelector('.pt-feed-list');
if (feed && !reduceMotion) {
  const beats = Array.from(feed.children);
  const FLOOR = 4;
  let count = FLOOR;
  const apply = (enterIdx) => {
    beats.forEach((b, i) => {
      b.style.display = i < count ? '' : 'none';
      b.classList.toggle('pt-beat--enter', i === enterIdx);
    });
  };
  apply(-1);
  setInterval(() => {
    count = count >= beats.length ? FLOOR : count + 1;
    apply(count === FLOOR ? -1 : count - 1);
  }, 2600);
}

/* ── waitlist form ───────────────────────────────────────────────────────
 * Stores the sign-up via the console API (POST /api/waitlist, #291) and shows
 * the confirmation only after the server says it was stored. See waitlist.ts. */
const form = document.querySelector('.pt-form');
if (form) attachWaitlist(form);
